<template>
	<layout-splash>
		<div class="card">
			<div class="card-header">{{ bidHeader }} {{ __("expires soon!") }}</div>
			<div class="card-body">
				{{ __("Your answer") }}:
				<div class="p-4">
					<h2>{{ __(response["label"]) }}</h2>

					<div v-if="alert" role="alert">{{ alert }}</div>
					<div v-else-if="response['key'] == 'price_not_right'">
						<ui-input-group
							class="col-span-6"
							v-model="form.price_idea"
							field="price_idea"
							label="Preisvorstellung"
							:form="form"
							:required="true"
						></ui-input-group>
						<ui-button v-on:click="submit()" type="primary">{{
							__("Send")
						}}</ui-button>
					</div>
				</div>
			</div>
			<tradable-terms-summary :offer="tradable"></tradable-terms-summary>
		</div>
	</layout-splash>
</template>

<script>
export default {
	props: {
		bidHeader: {
			type: String,
			required: true,
		},
		response: {
			type: Object,
			required: true,
		},
		alert: {
			type: String,
			required: false,
			default: null,
		},
		responseSubmitEndpoint: {
			type: String,
			required: true,
		},
		tradable: {
			type: Object,
			required: true,
		},
		counterpart: {
			type: Object,
			required: true,
		},
		counterpartRole: {
			type: String,
			required: true,
		},
		tableParameters: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			form: this.$inertia.form({
				price_idea: null,
			}),
		};
	},
	methods: {
		submit() {
			this.form.post(this.responseSubmitEndpoint);
		},
	},
};
</script>
